// extracted by mini-css-extract-plugin
export default {"container":"Checkout_container__VKwS7","accordion-container":"Checkout_accordion-container__TUIu2"};